export default __webpack_public_path__ + "static/media/united.ca504040.svg";